import { AbstractCollection } from '../../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable } from '../../../abstract/Document';
import { Weddings } from '../../Weddings';
import type { Agent } from '../Agents';
import type { ISkill } from './Skills.types';

@Identifiable
@Timestampable
export class Skill extends AbstractDocument<ISkill> {
  readonly collections = {};

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}

export class Skills extends AbstractCollection<Skill, ISkill> {
  static path = 'skills';

  constructor(document: Agent) {
    super(document.collection(Skills.path), Skill);
  }

  get agent() {
    return Weddings._.getById(this.ids.weddings).Agents.getById(this.ids.agents);
  }

  get wedding() {
    return this.agent.wedding;
  }
}
